import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "admin-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.css"]
})
export class ModalComponent {

  @Input() title: string

  @Output() titleEmitter = new EventEmitter<string>();

  modalTitleReceiver(title: string) {
    this.title = title;
  }

}
